export default __webpack_public_path__ + "static/media/image51.eab43d7f.png";